module.exports = __webpack_public_path__ + "static/media/FUNERALESMobile.f422dad7.jpg";